export const AGENT_IMG = { ai: "/laser-operator-agent.jpg", sales_coach: "/sales-coach-agent.png" };
export const ALR_LOGO_FINAL = "/alr-logo-horizontal-white.png";

// Circular agent photo with a hairline ring, as in the original app.
export const AgentAvatar = ({ kind = "ai", size = 56, ring = "var(--accent)", halo = false, testId }) => (
  <span className={`inline-flex shrink-0 items-center justify-center rounded-full ${halo ? "p-2" : ""}`} style={halo ? { background: "color-mix(in srgb, var(--accent) 10%, transparent)", boxShadow: "0 0 40px color-mix(in srgb, var(--accent) 25%, transparent)" } : undefined} data-testid={testId}>
    <img src={AGENT_IMG[kind]} alt={kind === "ai" ? "ALR Cleaning Agent" : "ALR Sales Coach"} width={size} height={size}
      className="rounded-full bg-black object-cover" style={{ width: size, height: size, border: `1px solid ${ring}` }} />
  </span>
);
